
<div class="spinner_content size_{{size}}">
    <i class="fas fa-spinner fa-{{size}} spinner_icon" aria-hidden="true"></i>
</div>
